import { render, staticRenderFns } from "./BaseModalV2.vue?vue&type=template&id=17a05f28&scoped=true&"
import script from "./BaseModalV2.vue?vue&type=script&lang=js&"
export * from "./BaseModalV2.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalV2.vue?vue&type=style&index=0&id=17a05f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a05f28",
  null
  
)

export default component.exports